export default __webpack_public_path__ + "710ec2335e84af7fbc37a358634bb7cf.svg";